import type { FC } from 'react'
import { memo } from 'react'
import { useCallback } from 'react'
import type { LinkProps } from 'react-router-dom'
import { Link } from 'react-router-dom'

import type { ChatNavigationContextType } from '@app/pages/strategies/components/aiChat/contexts/aiChatNavigationContext'
import { useChatNavigationContext } from '@app/pages/strategies/components/aiChat/contexts/aiChatNavigationContext'

type Props = Omit<LinkProps, 'to'> & {
  to: keyof ChatNavigationContextType | [keyof ChatNavigationContextType, string]
}

const ContextLink: FC<Props> = ({ to, onClick = undefined, ...props }) => {
  const navContext = useChatNavigationContext()

  const newOnClick = useCallback(
    (e) => {
      e.preventDefault()
      const [action, id] = Array.isArray(to) ? to : [to]

      onClick?.(e)
      navContext[action](id)
    },
    [navContext, onClick, to]
  )

  return <Link to="" onClick={newOnClick} {...props} />
}

export default memo(ContextLink)
